import { QueryClient } from '@tanstack/vue-query';

import { ENTITY_LIST_QUERY_OPTIONS } from './constants';

export function createAppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        ...ENTITY_LIST_QUERY_OPTIONS,
        retry: 1,
      },
    },
  });
}
